import React from 'react';
import { useDispatch } from 'react-redux';
import CustomNumberInput from '../../../../components/CustomNumberInput';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { Helpers } from '../../../../helpers/Helpers';
import { storeImageViewer } from '../../../../redux/reducers/authSlice';
import { ConstantService } from '../../../../services/ConstantService';
import { CountryService } from '../../../../services/CountryService';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';

interface Props {
    identityInformationRef: any
    identitySerialNumber: string | undefined
    setIdentitySerialNumber: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedCitizenship: CustomSingleSelectModel | undefined
    setSelectedCitizenship: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    identityValidityDate: string | undefined
    setIdentityValidityDate: React.Dispatch<React.SetStateAction<string | undefined>>
    age: string | undefined
    setAge: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedGender: CustomSingleSelectModel | undefined
    setSelectedGender: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    tckn: string | undefined
    setTckn: React.Dispatch<React.SetStateAction<string | undefined>>
    identityFileB64: string
    identityFileRef: any
    setIdentityFile: React.Dispatch<React.SetStateAction<File | undefined>>
    setIdentityFileB64: React.Dispatch<React.SetStateAction<string>>
    handleFileRead: (event: any, setFunction: React.Dispatch<React.SetStateAction<string>>) => Promise<void>
    selectedCitizenshipCountry: CustomSingleSelectModel | undefined
    setSelectedCitizenshipCountry: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
}

const IdentityInformation = ({
    identityInformationRef,
    identitySerialNumber,
    setIdentitySerialNumber,
    selectedCitizenship,
    setSelectedCitizenship,
    identityValidityDate,
    setIdentityValidityDate,
    age,
    setAge,
    selectedGender,
    setSelectedGender,
    setTckn,
    tckn,
    identityFileB64,
    identityFileRef,
    setIdentityFile,
    setIdentityFileB64,
    handleFileRead,
    selectedCitizenshipCountry,
    setSelectedCitizenshipCountry
}: Props) => {
    const dispatch = useDispatch();

    return (
        <div className='containerPart' ref={identityInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Kimlik Bilgileri</h4>

                    <div className='row'>
                        <div className='col-md-9'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Uyruğu</label>

                                    <CustomSingleSelect
                                        selectedValue={selectedCitizenship}
                                        onChange={setSelectedCitizenship}
                                        onMenuOpen={() => ConstantService.getConstantList('CITIZENSHIP', undefined, undefined)}
                                        labelName='value'
                                        valueName='constantId'
                                        additionalValue1Name='additionalValue1'
                                    />
                                </div>

                                <div className='col-md-6'>
                                    <label htmlFor="exampleFormControlInput1" className={"form-label " + (selectedCitizenship?.additionalValue1 == 'TC' ? 'required' : '')}>TC Kimlik No</label>
                                    <input style={{ border: '1px solid #F1F1F4' }} value={tckn} onChange={(e) => setTckn(e.target.value)} type="number" className="form-control form-control-solid" />
                                </div>
                            </div>

                            <div className='row mt-5'>
                                <div className='col-md-6'>
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Uyruğu</label>

                                    <CustomSingleSelect
                                        selectedValue={selectedCitizenshipCountry}
                                        onChange={setSelectedCitizenshipCountry}
                                        onMenuOpen={() => CountryService.getCountryList()}
                                        labelName='name'
                                        valueName='countryId'
                                    />
                                </div>

                                <div className='col-md-6'>
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Cinsiyeti</label>

                                    <CustomSingleSelect
                                        selectedValue={selectedGender}
                                        onChange={setSelectedGender}
                                        onMenuOpen={() => ConstantService.getConstantList('GENDER')}
                                        labelName='value'
                                        valueName='constantId'
                                    />
                                </div>
                            </div>

                            <div className='row mt-5'>
                                <div className='col-md-6'>
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Geçerlilik Tarihi</label>
                                    <input style={{ border: '1px solid #F1F1F4' }} value={identityValidityDate} onChange={(e) => setIdentityValidityDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                </div>

                                <div className='col-md-6'>
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Kimlik Seri No</label>
                                    <input style={{ border: '1px solid #F1F1F4' }} value={identitySerialNumber} onChange={(e) => setIdentitySerialNumber(e.target.value)} type="text" className="form-control form-control-solid" />
                                </div>
                            </div>

                            <div className='row mt-5'>
                                <div className='col-md-6'>
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Yaş</label>
                                    <CustomNumberInput value={age} setValue={setAge} isDisabled />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Kimlik Resmi</label>

                            <div>
                                <img onClick={() => dispatch(storeImageViewer([identityFileB64]))} style={{ width: '100%' }} className="actionIcon img img-thumbnail" src={identityFileB64} />

                                <div className='mt-5 p-3 img img-thumbnail d-flex'>
                                    <div className='d-flex flex-grow-1'>
                                        <input accept="image/*" ref={identityFileRef} onChange={(e) => { setIdentityFile(e && e.target && e.target.files && e.target.files.length > 0 ? e.target.files[0] : undefined); handleFileRead(e, setIdentityFileB64); }} type="file" className="form-control form-control-solid" />
                                    </div>

                                    {
                                        !Helpers.isEmpty(identityFileB64) && (
                                            <div style={{ marginLeft: 15 }} className='d-flex align-items-center'>
                                                <i onClick={() => { setIdentityFile(undefined); setIdentityFileB64(Helpers.getPlaceholder()); identityFileRef.current.value = ""; }} style={{ fontSize: 18 }} className='actionIcon text-danger fa fa-trash' />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default IdentityInformation;